import { useMediaQuery } from '@mantine/hooks';
import React, { useEffect, useMemo, useState } from 'react';
import Navigation from '../sidebar/Navigation';
import './MyInquiryDetails.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { createB2BAPI } from '../../../api/Interceptor';
import { BASE_URL } from '../../../api/EndPoints';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

const MyInquiryDetails = () => {
    const navigate = useNavigate();
        const isMobile = useMediaQuery('(max-width: 767px)');
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
    const isMobileOrTablet = useMediaQuery('(max-width: 991px)');  // Combine mobile and tablet into one
    const isLaptop = useMediaQuery('(min-width: 992px)');
    const [showInquiryDetails, setShowInquiryDetails] = useState(false);
    const [inquiryData, setInquiryData] = useState(null); 

    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    useEffect(() => {
        fetchFabricData();
    }, []);

    const fetchFabricData = async () => {
        try {
            const res = await B2B_API.get(`fabricInquiry/${id}`).json();
            setInquiryData(res.response);
        } catch (error) {
            console.error('Error fetching fabricInquiry:', error);
        }
    };

    const handleViewInquiryClick = () => {
        setShowInquiryDetails(true);
    };

    const handleCloseClick = () => {
        setShowInquiryDetails(false);
    };

    const renderTimeline = () => (
        <div className="fabric-inquiry-timeline">
            <div className="timeline-item">
                <div className="timeline-header">
                    <div className="square"></div>
                    <div className="titlefont">Fabric inquiry submitted</div>
                </div>
                <div className="timeline-body">
                    <div className="outer">
                        <div className="date">{formatDate(inquiryData?.createdDate)}</div>
                    </div>
                </div>
            </div>
        </div>
    );

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short', 
            day: 'numeric'
        });
    }

    return (
        <div className="view-my-page router-view-container">
            {!isMobileOrTablet && <Navigation />}
            <div className="view-fabric-inquiry-detail-v2 route-view">
                <div className="top">
                    <div style={{display:"flex",justifyContent:"space-between"}}>
                    <div className="page-titless">{inquiryData?.endUse} </div>
                      {!isMobile &&  <Button
                                color='#8BC54F'
                                onClick={() => navigate("/fabricInquiries")}
                                leftSection={<IconArrowLeft stroke={2} />}
                                >
                                Back
                              </Button>}
                                  </div>
                    <div className="status-container">
                        <div className="fabric-inquiry-status-v2 border">
                            <div className={`circle blue ${inquiryData?.isProgress ? 'in-progress' : 'Complete'}`}></div>
                            <div>{inquiryData?.isProgress ? 'In Progress' : 'Complete'}</div>
                        </div>
                        {isMobileOrTablet && !showInquiryDetails && (
                            <button className="btns btn-view-inquirys" onClick={handleViewInquiryClick}>
                                VIEW INQUIRY
                            </button>
                        )}
                    </div>
                </div>

                <div className="bottom">
                    <div className="left">{renderTimeline()}</div>
                    {(showInquiryDetails || isLaptop) && inquiryData && (
                        <div className="right">
                            <div className="right-header">
                                <div className="titlefont"> My inquiry </div>
                                {isMobileOrTablet && (
                                    <FontAwesomeIcon
                                        icon={faXmark}
                                        className="close-btn"
                                        onClick={handleCloseClick}
                                    />
                                )}
                            </div>
                            <div className="submitted">{formatDate(inquiryData?.createdDate)}</div>
                            <div className="fabric-inquiry-image-list">
                                <div className="img-container" style={{ width: '44px', height: '44px', cursor: 'pointer' }}>
                                    <img 
                                        src={`${BASE_URL.replace("/api","")}${inquiryData?.referenceImage}?time=${Date?.now()}`}
                                        alt="Fabric Inquiry"
                                    />
                                </div>
                            </div>
                            <div className="key-value">
                                <div className="key">End Use</div>
                                <div className="value">{inquiryData?.endUse}</div>
                            </div>
                            <div className="key-value">
                                <div className="key">Season</div>
                                <div className="value">{inquiryData?.season}</div>
                            </div>
                            <div className="key-value">
                                <div className="key">Fabric Type</div>
                                <div className="value">{inquiryData?.fabricType}</div>
                            </div>
                            <div className="key-value">
                                <div className="key">Fiber Composition</div>
                                <div className="value">{inquiryData?.fiberComposition}</div>
                            </div>
                            <div className="key-value">
                                <div className="key">Weight</div>
                                <div className="value">{inquiryData?.weightMin} - {inquiryData?.weightMax} gsm</div>
                            </div>
                            <div className="key-value">
                                <div className="key">Finish or Performance</div>
                                <div className="value">{inquiryData?.finishPerformance}</div>
                            </div>
                            <div className="key-value">
                                <div className="key">Target Price</div>
                                <div className="value">${inquiryData?.priceMin} - ${inquiryData?.priceMax}</div>
                            </div>
                            <div className="key-value">
                                <div className="key">Expected Order Amount</div>
                                <div className="value">{inquiryData?.expectedOrderAmount} yards</div>
                            </div>
                            <div className="key-value">
                                <div className="key">Note</div>
                                <div className="value">{inquiryData?.note}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MyInquiryDetails;
